import api from './client';

export interface User {
  id: number;
  email: string;
  is_active: boolean;
  is_staff: boolean;
}

export interface AuthResponse {
  user: User;
}

export const login = async (email: string, password: string): Promise<AuthResponse> => {
  const res = await api.post<AuthResponse>('/auth/login/', { email, password });
  return res.data;
};

export const register = async (email: string, password: string, password_confirm: string): Promise<AuthResponse> => {
  const res = await api.post<AuthResponse>('/auth/register/', { email, password, password_confirm });
  return res.data;
};

export const logout = async () => {
  await api.post('/auth/logout/', {}).catch(() => {});
};

export const getMe = async (): Promise<User> => {
  const res = await api.get<User>('/auth/me/');
  return res.data;
};
